var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.photoUrl)?_c('span',{staticClass:"white--text headline"},[_vm._v("\n  "+_vm._s(!_vm.name ? '?' : _vm.name.charAt())+"\n")]):_c('img',{attrs:{"src":_vm.photoUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }